import { useFormContext } from "react-hook-form"
import { TikTokIcon } from "~/common/SocialMediaIcons"
import { IconHeading } from "~/ui/IconHeading"
import { Switch } from "~/ui/Switch"
import {
  CastingCallFormValues,
  ENG_RATE_MAX,
  ENG_RATE_MIN,
  FOLLOWERS_MAX,
  FOLLOWERS_MIN,
  FOLLOWERS_STEP,
  VIEWS_MAX,
  VIEWS_MIN,
  VIEWS_STEP,
} from "../../data/castingCallSchema"
import { FormField, FormItem, FormMessage } from "~/shadcn/ui/form"
import Text from "~/ui/typography"
import { RangeInput } from "./RangeInput"
import { PercentRangeInput } from "./PercentRangeInput"

export const TikTokFields = () => {
  const form = useFormContext<CastingCallFormValues>()

  const enabled = form.watch("tikTokEnabled") || false

  return (
    <>
      <IconHeading
        icon={<TikTokIcon />}
        title="TikTok"
        className="mb-4"
        rightSide={
          <Switch
            enabled={enabled}
            setEnabled={(newEnabled) =>
              form.setValue("tikTokEnabled", newEnabled)
            }
          />
        }
      />
      {enabled && (
        <div className="grid grid-cols-3 gap-8">
          <FormField
            control={form.control}
            name="tikTokFollowers"
            render={({ field }) => (
              <FormItem>
                <Text variant="body3">FOLLOWERS</Text>
                <RangeInput
                  {...field}
                  min={FOLLOWERS_MIN}
                  max={FOLLOWERS_MAX}
                  step={FOLLOWERS_STEP}
                  disabled={!enabled}
                />
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="tikTokAverageViews"
            render={({ field }) => (
              <FormItem>
                <Text variant="body3">AVERAGE VIEWS</Text>
                <RangeInput
                  {...field}
                  min={VIEWS_MIN}
                  max={VIEWS_MAX}
                  step={VIEWS_STEP}
                  disabled={!enabled}
                />
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="tikTokEngagementRate"
            render={({ field }) => (
              <FormItem>
                <Text variant="body3">ENG RATE</Text>
                <PercentRangeInput
                  {...field}
                  min={ENG_RATE_MIN}
                  max={ENG_RATE_MAX}
                  disabled={!enabled}
                />
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      )}
    </>
  )
}
